import isValidDateString from "../utils/isValidDateString"
import getPositionsBaseOnDateIntervals from "./getPositionsBaseOnDateIntervals"

export default function(categories) {
    return function() {
        let positions = []
        const matchingValuesInRow = countMatchingValuesInRow(categories)
        positions = getPositionsOfMatchingIntervals(matchingValuesInRow)

        if (positions.length === categories.length) {
            const isDateType = checkIfCategoryIsTypeDate(categories)
            if (isDateType) {
                positions = getPositionsBaseOnDateIntervals(categories)
            }
        }

        return positions
    }
}

function countMatchingValuesInRow(arr) {
    let result = []
    let currentCount = 1

    for (let i = 1; i < arr.length; i++) {
        if (arr[i] === arr[i - 1]) {
            currentCount++
        } else {
            result.push(currentCount)
            currentCount = 1
        }
    }

    result.push(currentCount)
    return result
}

function getPositionsOfMatchingIntervals(matchingValuesInRow) {
    const array = []
    matchingValuesInRow.map((item, index) => {
        let val = 0 
        if (index === 1) {
            val = matchingValuesInRow[0]
        } else if (index > 1) {
            val = matchingValuesInRow[index - 1] + array[index - 1]
        } 
        array.push(val)
    })
    return array
}

function checkIfCategoryIsTypeDate(categories) {
    return categories.every(isValidDateString)
}
